import React, { useState } from 'react';
import { Input, Select, Button, Space, Card } from 'antd';
import { UnlockOutlined } from '@ant-design/icons';
import axios from 'axios';

import Cookies from 'js-cookie';
import { DiffChecker_URL } from '../../Components/Constant';

const { Option } = Select;

const OrgAuthenticate = () => {

    const options = ['Sandbox', 'Production'];
    const [name, setName] = useState('');
    const [instanceUrl, setInstanceUrl] = useState('');
    const [sandbox, setSandbox] = useState(null);
    const [loginFailed, setLoginFailed] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const options = {
                method: 'POST',
                url: `${DiffChecker_URL}/authorize/getLoginUrl`,
                data: {
                    Name: name,
                    connectionType: sandbox,
                    InstanceUrl: instanceUrl
                },
                headers: {
                    'Content-Type': 'application/json',
                    connectionType: sandbox
                },
            };

            const response = await axios(options);

            let url = response.data.url;


            if (url) {
                window.location.href = url;

            }


        } catch (error) {
            console.error('There was an error!', error);
        }
    };




    return (
        <Card
            style={{ width: '40%', margin: '50px auto' }}
            bodyStyle={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}
        >
            <UnlockOutlined style={{ fontSize: 40, marginBottom: 16 }} />
            <h2>Authorize</h2>

            {/* Org Name Input */}
            <div style={{ display: 'flex', flexDirection: 'column', width: '100%', marginBottom: 10 }}>
                <span style={{ marginBottom: 4 }}>Org Name</span>
                <Input
                    name="nameInput"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    placeholder="Enter Org Name"
                />
            </div>

            {/* Instance URL Input */}
            <div style={{ display: 'flex', flexDirection: 'column', width: '100%', marginBottom: 10 }}>
                <span style={{ marginBottom: 4 }}>Instance Url</span>
                <Input
                    name="instanceUrlInput"
                    value={instanceUrl}
                    onChange={(e) => setInstanceUrl(e.target.value)}
                    placeholder="Enter Instance Url"
                />
            </div>

            {/* Instance Type Select */}
            <div style={{ display: 'flex', flexDirection: 'column', width: '100%', marginBottom: 10 }}>
                <span style={{ marginBottom: 4 }}>Instance Type</span>
                <Select
                    value={sandbox?.label || undefined}
                    onChange={setSandbox}
                    placeholder="Select Instance Type"
                    style={{ width: '100%' }}
                >
                    {options.map(opt => (
                        <Option key={opt} value={opt}>
                            <Space>{opt}</Space>
                        </Option>
                    ))}
                </Select>
            </div>

            {/* Submit Button */}
            <Button
                type="primary"
                style={{ width: '20%', marginTop: 15 }}
                onClick={handleSubmit}
            >
                Submit
            </Button>

            {/* Error Message */}
            {loginFailed && (
                <p style={{ color: 'red', marginTop: 10 }}>
                    Invalid username or password. Please try again.
                </p>
            )}
        </Card>
    );

}


export default OrgAuthenticate;
